export default __webpack_public_path__ + "static/media/logo-white.50c14de9.png";